import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalPage = ({ title, sections, testId }) => (
    <section
        className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-10 lg:py-14"
        data-testid={testId}
    >
        <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
        >
            <ArrowLeft className="h-4 w-4" /> Back to home
        </Link>
        <h1 className="mt-6 text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight">
            {title}
        </h1>
        <div className="mt-8 space-y-6 glass-card rounded-3xl p-6 lg:p-8">
            {sections.map((s) => (
                <div key={s.heading}>
                    <h2 className="text-lg font-display font-semibold tracking-tight">
                        {s.heading}
                    </h2>
                    <p className="mt-2 text-sm sm:text-base text-muted-foreground leading-relaxed">
                        {s.body}
                    </p>
                </div>
            ))}
            <p className="text-xs text-muted-foreground pt-4 border-t border-border/60">
                Last updated: September 2026
            </p>
        </div>
    </section>
);

export const PrivacyPage = () => (
    <LegalPage
        testId="privacy-page"
        title="Privacy Policy"
        sections={[
            {
                heading: "Information we collect",
                body: "We collect only the information necessary to deliver requested services — such as name, mobile number, email and documents you provide. We never sell your personal data.",
            },
            {
                heading: "How we use it",
                body: "Your information is used strictly to process your requests, communicate updates and improve service quality. Where required by law, we retain records for the mandated period.",
            },
            {
                heading: "Security",
                body: "We follow industry-standard practices including encrypted transmission, restricted access and periodic reviews to keep your data safe.",
            },
            {
                heading: "Your rights",
                body: "You may request access, correction or deletion of your data at any time by contacting us through the details on our Contact page.",
            },
        ]}
    />
);

export const TermsPage = () => (
    <LegalPage
        testId="terms-page"
        title="Terms & Conditions"
        sections={[
            {
                heading: "Service scope",
                body: "Smart Solutions provides online assistance for form filling, registrations, WhatsApp bulk messaging and money transfer distribution. Approval of any application by a third party (government or private) is subject to their sole discretion.",
            },
            {
                heading: "Fees & refunds",
                body: "Service fees are communicated before work begins. Refunds are available only where work has not been initiated or where explicitly stated for a specific service.",
            },
            {
                heading: "User responsibilities",
                body: "You are responsible for providing accurate information and lawful documents. Misuse of our messaging or money transfer services will lead to immediate termination.",
            },
            {
                heading: "Third-party forms & intellectual property",
                body: "Smart Solutions provides only an online utility to assist users in filling and printing publicly available application forms. All form names, logos, trademarks, formats and copyrights belong to their respective banks, government departments, institutions or other rightful owners. Smart Solutions does not claim ownership of such third-party material and is not affiliated with, endorsed by or authorized by any bank, government authority or institution unless specifically stated. Users should verify that they are using the latest applicable form before submission. Smart Solutions does not guarantee acceptance, approval or processing of any application by the concerned authority.",
            },
            {
                heading: "Contact",
                body: "For any questions about these terms, please reach out through our Contact page.",
            },
        ]}
    />
);
